import { render, staticRenderFns } from "./MangerWord.vue?vue&type=template&id=0a8056e1"
import script from "./MangerWord.vue?vue&type=script&lang=js"
export * from "./MangerWord.vue?vue&type=script&lang=js"
import style0 from "./MangerWord.vue?vue&type=style&index=0&id=0a8056e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports